"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The GetAlertsCommonParams model module.
 * @module model/GetAlertsCommonParams
 * @version 4.0.0
 */
var GetAlertsCommonParams = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>GetAlertsCommonParams</code>.
   * @alias module:model/GetAlertsCommonParams
   */
  function GetAlertsCommonParams() {
    _classCallCheck(this, GetAlertsCommonParams);
    GetAlertsCommonParams.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(GetAlertsCommonParams, null, [{
    key: "initialize",
    value: function initialize(obj) {
      obj['priority'] = '0';
      obj['no_change_alerts'] = '0';
    }

    /**
     * Constructs a <code>GetAlertsCommonParams</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/GetAlertsCommonParams} obj Optional instance to populate.
     * @return {module:model/GetAlertsCommonParams} The populated <code>GetAlertsCommonParams</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new GetAlertsCommonParams();
        if (data.hasOwnProperty('institution_id')) {
          obj['institution_id'] = _ApiClient["default"].convertToType(data['institution_id'], 'Number');
        }
        if (data.hasOwnProperty('startDate')) {
          obj['startDate'] = _ApiClient["default"].convertToType(data['startDate'], 'String');
        }
        if (data.hasOwnProperty('endDate')) {
          obj['endDate'] = _ApiClient["default"].convertToType(data['endDate'], 'String');
        }
        if (data.hasOwnProperty('compareToStartDate')) {
          obj['compareToStartDate'] = _ApiClient["default"].convertToType(data['compareToStartDate'], 'String');
        }
        if (data.hasOwnProperty('compareToEndDate')) {
          obj['compareToEndDate'] = _ApiClient["default"].convertToType(data['compareToEndDate'], 'String');
        }
        if (data.hasOwnProperty('priority')) {
          obj['priority'] = _ApiClient["default"].convertToType(data['priority'], 'String');
        }
        if (data.hasOwnProperty('no_change_alerts')) {
          obj['no_change_alerts'] = _ApiClient["default"].convertToType(data['no_change_alerts'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>GetAlertsCommonParams</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>GetAlertsCommonParams</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['startDate'] && !(typeof data['startDate'] === 'string' || data['startDate'] instanceof String)) {
        throw new Error("Expected the field `startDate` to be a primitive type in the JSON string but got " + data['startDate']);
      }
      // ensure the json data is a string
      if (data['endDate'] && !(typeof data['endDate'] === 'string' || data['endDate'] instanceof String)) {
        throw new Error("Expected the field `endDate` to be a primitive type in the JSON string but got " + data['endDate']);
      }
      // ensure the json data is a string
      if (data['compareToStartDate'] && !(typeof data['compareToStartDate'] === 'string' || data['compareToStartDate'] instanceof String)) {
        throw new Error("Expected the field `compareToStartDate` to be a primitive type in the JSON string but got " + data['compareToStartDate']);
      }
      // ensure the json data is a string
      if (data['compareToEndDate'] && !(typeof data['compareToEndDate'] === 'string' || data['compareToEndDate'] instanceof String)) {
        throw new Error("Expected the field `compareToEndDate` to be a primitive type in the JSON string but got " + data['compareToEndDate']);
      }
      // ensure the json data is a string
      if (data['priority'] && !(typeof data['priority'] === 'string' || data['priority'] instanceof String)) {
        throw new Error("Expected the field `priority` to be a primitive type in the JSON string but got " + data['priority']);
      }
      // ensure the json data is a string
      if (data['no_change_alerts'] && !(typeof data['no_change_alerts'] === 'string' || data['no_change_alerts'] instanceof String)) {
        throw new Error("Expected the field `no_change_alerts` to be a primitive type in the JSON string but got " + data['no_change_alerts']);
      }
      return true;
    }
  }]);
}();
/**
 * Institution ID
 * @member {Number} institution_id
 */
GetAlertsCommonParams.prototype['institution_id'] = undefined;

/**
 * Start date of the considered period in 'YYYY-MM-DD' format. All four dates should ve provided. The only case when you can provide just `startDate` is when you select _All Time_ period.
 * @member {String} startDate
 */
GetAlertsCommonParams.prototype['startDate'] = undefined;

/**
 * End date of the considered period in 'YYYY-MM-DD' format.
 * @member {String} endDate
 */
GetAlertsCommonParams.prototype['endDate'] = undefined;

/**
 * Start date of the previous period in 'YYYY-MM-DD' format. Now we suppose that considered and previous period are equal.
 * @member {String} compareToStartDate
 */
GetAlertsCommonParams.prototype['compareToStartDate'] = undefined;

/**
 * End date of the previous period in 'YYYY-MM-DD' format. Now we suppose that considered and previous period are equal.
 * @member {String} compareToEndDate
 */
GetAlertsCommonParams.prototype['compareToEndDate'] = undefined;

/**
 * If priority is not provided, or if it is set to '0', null, empty, or false, then all alerts will be returned. If set to '1', or true - only prior alerts will be returned.
 * @member {module:model/GetAlertsCommonParams.PriorityEnum} priority
 * @default '0'
 */
GetAlertsCommonParams.prototype['priority'] = '0';

/**
 * If this parameter is not provided, or if it is set to '0', null, or false, then all alerts will be returned (absolute and change ones). If set to '1', or true - only absolute alerts will be returned.
 * @member {module:model/GetAlertsCommonParams.NoChangeAlertsEnum} no_change_alerts
 * @default '0'
 */
GetAlertsCommonParams.prototype['no_change_alerts'] = '0';

/**
 * Allowed values for the <code>priority</code> property.
 * @enum {String}
 * @readonly
 */
GetAlertsCommonParams['PriorityEnum'] = {
  /**
   * value: "0"
   * @const
   */
  "0": "0",
  /**
   * value: "1"
   * @const
   */
  "1": "1"
};

/**
 * Allowed values for the <code>no_change_alerts</code> property.
 * @enum {String}
 * @readonly
 */
GetAlertsCommonParams['NoChangeAlertsEnum'] = {
  /**
   * value: "0"
   * @const
   */
  "0": "0",
  /**
   * value: "1"
   * @const
   */
  "1": "1"
};
var _default = exports["default"] = GetAlertsCommonParams;